import React from "react"
import Image from "../components/image"
import menuData from "../data/menu.json"
import findObject from "../helpers/find-object"
import { Link } from "gatsby"

export default function ReadNext({ sectionID, pageID }) {
  const menu = findObject(menuData, "id", sectionID)
  const content =
    menu && pageID ? findObject(menu.children, "id", pageID) : menu

  return (
    <Link className="read-next" to={content.href}>
      <div className="read-next__inner">
        <span className="title--meta title--uppercase title--light">
          Read Next
        </span>
        <h3 className="title--secondary title--uppercase">{content.name}</h3>
      </div>

      <Image
        path={content.featured_image}
        alt={`Read next: ${content.name}`}
        className="read-next__image"
      />
    </Link>
  )
}
